import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserModel } from 'app/_core/models/user.model';
import { UserService } from 'app/_core/services/user.service';

@Component({
  selector: 'app-validation-rules-modal',
  templateUrl: './validation-rules-modal.component.html',
  standalone: false,
})
export class ValidationRulesModalComponent implements OnInit {
  specielCharacters: string;
  keyWord: string;
  user: UserModel;

  path: string;

  constructor(
    private router: Router,
    protected userService: UserService
  ) {}

  ngOnInit() {
    this.path = this.router.url;
    if (this.path.includes('user-recovery') || this.path.includes('user-verify')) {
      this.keyWord = '>, !, ?, ", SAP, PASS, PASSWORD, EREDES';
    } else {
      this.user = this.userService.getUser();
      const company = this.user ? this.user.retailerAlias.toUpperCase() : '';
      this.keyWord = '>, !, ?, ", SAP, PASS, PASSWORD, EREDES, ' + company.replace(/\s/g, '');
    }
    this.specielCharacters = "@#$%&*()_+=-{}[]|\:;'<,./:";
  }
}
